import { combineReducers } from 'redux';
import { splitReducer } from '@splitsoftware/splitio-redux';
import webinarsReducer from './webinars';
import participantsReducer from './participants';
import contactsReducer from './contacts';
import auditoriumsReducer from './auditoriums';
import localizationReducer from './localization';
import loginTimeReducer from './loginTime';
import productCategoriesReducer from './productCategories';
import searchResultsReducer from './searchResults';
import bookmarksReducer from './bookmarks';
import productsReducer from './products';
import selectedProductReducer from './selectedProduct';
import rtcCallingInfoReducer from './rtcCallingInfo';
import rtcCallingStatusReducer from './rtcCallingStatus';
import rtcGlobalsReducer from './rtcGlobals';
import cmsReducer from './cms';
import boothProductsReducer from './boothProducts';
import eventConfigsReducer from './virtual_event';
import locationReducer from './location';
import questionReducer from './questions';
import participantFilterReducer from './participantFilter';
import profileModalReducer from './profileModal';
import firstTimeProfilePictureModalReducer from './firstTimeProfilePictureModal';
import liveStreamReducer from './liveStream';
import { LIVESTREAM_STORE_NAME } from './liveStream/reducers';
import twilioReducer, { preloadReducer } from './twilio';
import landingReducer from './landing';
import userActivityLogReducer from './userActivityLog';
import enrichmentDataReducer from './enrichmentData';
import singleAttendeeActivityLogReducer from './singleAttendeeActivityLog';
import networkingLoungeReducer from './networking_lounge';

export default combineReducers({
  webinars: webinarsReducer,
  participants: participantsReducer,
  contacts: contactsReducer,
  boothProducts: boothProductsReducer,
  localization: localizationReducer,
  loginTime: loginTimeReducer,
  products: productsReducer,
  productCategories: productCategoriesReducer,
  selectedProduct: selectedProductReducer,
  searchResults: searchResultsReducer,
  rtcCallingInfo: rtcCallingInfoReducer,
  rtcCallingStatus: rtcCallingStatusReducer,
  rtcGlobals: rtcGlobalsReducer,
  bookmarks: bookmarksReducer,
  cms: cmsReducer,
  auditoriums: auditoriumsReducer,
  eventConfigs: eventConfigsReducer,
  location: locationReducer,
  splitio: splitReducer,
  questions: questionReducer,
  participantFilter: participantFilterReducer,
  profileModal: profileModalReducer,
  firstTimeProfilePictureModal: firstTimeProfilePictureModalReducer,
  [LIVESTREAM_STORE_NAME]: liveStreamReducer,
  twilio: twilioReducer,
  twilioPreload: preloadReducer,
  landing: landingReducer,
  userActivityLog: userActivityLogReducer,
  enrichmentData: enrichmentDataReducer,
  singleAttendeeActivityLog: singleAttendeeActivityLogReducer,
  networkingLounge: networkingLoungeReducer,
});
